// image-processing-loader
var previousRequest = require("!!../../../../../../node_modules/fox-file-loader/index.js!../../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./li_style.png");
var dir = previousRequest.replace("li_style.png", "")
module.exports = require("!../../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "li_style.png",
	name: "li_style",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/join/li_style.png
// module id = 1064
// module chunks = 4